"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.termsAndConditions = exports.needAnAccountLink = exports.modal = exports.listingConst = exports.launchTAndC = exports.elementList = exports.connectWithoutTAndC = exports.connectLoyaltyNumber = exports.categoryDropdown = exports.button = exports.actionList = exports.VALUES = exports.TYPES = exports.ReqInfo = exports.EVENTS = exports.CONTEXTS = exports.APPLICATION_NAME = void 0;
var EVENTS = exports.EVENTS = {
  CLICK: 'CLICK'
};
var TYPES = exports.TYPES = {
  LISTING: 'LISTING',
  BUTTON: 'BUTTON',
  LINK: 'LINK'
};
var CONTEXTS = exports.CONTEXTS = {
  HOME: 'HOME',
  LISTING_DETAILS: 'LISTING_DETAILS'
};
var VALUES = exports.VALUES = {
  CATEGORY: 'CATEGORY'
};
var APPLICATION_NAME = exports.APPLICATION_NAME = 'appcenter';
var elementList = exports.elementList = {
  button: 'button',
  link: 'link',
  menuItem: 'menuitem'
};
var actionList = exports.actionList = {
  click: 'click'
};
var termsAndConditions = exports.termsAndConditions = 'Terms and Conditions Panel';
var button = exports.button = {
  accept: 'accept',
  cancel: 'cancel',
  connect: 'connect',
  disconnect: 'disconnect',
  enroll: 'enroll',
  unenroll: 'unenroll',
  yes: 'yes',
  no: 'no',
  x: 'close'
};
var modal = exports.modal = {
  enroll: 'enroll modal',
  unenroll: 'unenroll modal',
  disconnect: 'disconnect modal'
};
var connectLoyaltyNumber = exports.connectLoyaltyNumber = 'Connect Loyalty Number section';
var needAnAccountLink = exports.needAnAccountLink = 'Need an Account Link';
var ReqInfo = exports.ReqInfo = 'Request Information';
var launchTAndC = exports.launchTAndC = 'Launch Terms and Conditions Panel';
var connectWithoutTAndC = exports.connectWithoutTAndC = 'Connect without launching Terms and Conditions Panel';
var listingConst = exports.listingConst = 'listing';
var categoryDropdown = exports.categoryDropdown = 'Category Dropdown Menu Option';